export default {
  duration: {
    short: 350,
  },
}
